module.exports = __webpack_public_path__ + "static/media/mobileSecondaryAuthMock.07055e59.png";